import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocalFloristIcon(props: IconProps) {
    return <Icon {...props} iconKey={"local_florist"}/>
}
